<nb-card>
    <nb-card-body>
        <div class="content">
            <div *ngIf="imageChangedEvent == null && selectedImage == null" class="empty-img"
                [style.max-height.px]="options.viewMaxHeight > 0 ? options.viewMaxHeight > 600 ? 600 : options.viewMaxHeight : 310">
                <img src="assets/img/not-found.png" alt=""
                    [style.max-height.px]="options.viewMaxHeight > 0 ? options.viewMaxHeight > 600 ? 600 : options.viewMaxHeight : 300"
                    [style.max-width.px]="options.viewMaxHeight > 0 ? options.viewMaxHeight > 600 ? 600 : options.viewMaxHeight : 300">
            </div>

            <div *ngIf="imageChangedEvent != null" class="cropper-img border">
                <image-cropper [style.max-height.px]="options.viewMaxHeight" [style.max-width.px]="options.viewMaxWidth"
                    [style.min-height.px]="options.viewMinHeight" [style.min-width.px]="options.viewMinWidth"
                    [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="options.maintainAspectRatio"
                    [aspectRatio]="options.aspectRatio" format="png" [cropperMinWidth]="options.cropperMinWidth"
                    [cropperMinHeight]="options.cropperMinHeight" [cropperMaxWidth]="options.cropperMaxWidth"
                    [resizeToWidth]="options.resizeToWidth" [resizeToHeight]="options.resizeToHeight"
                    [onlyScaleDown]="true" [cropperMaxHeight]="options.cropperMaxHeight"
                    (imageCropped)="imageCropped($event)" (loadImageFailed)="loadImageFailed($$event)"></image-cropper>
            </div>

            <div *ngIf="imageChangedEvent == null && selectedImage != null" class="cropper-img">
                <div class="border">
                    <img [src]="selectedImage" [style.max-height.px]="options.viewMaxHeight"
                        [style.max-width.px]="options.viewMaxWidth" [style.min-height.px]="options.viewMinHeight"
                        [style.min-width.px]="options.viewMinWidth">
                </div>

            </div>
            <input type="file" accept=".png, .jpg, .jpeg" (change)="fileChangeEvent($event)" #uploader hidden />
        </div>
    </nb-card-body>
    <nb-card-footer>
        <div class="modal-footer">
            <button nbButton matRipple status="primary" class="btn" (click)="acceptImg()"
                *ngIf="imageChangedEvent == null && selectedImage != null">
                Accept
                <!-- {{'components.img-cropper.accept' | translate}} -->
            </button>
            <button nbButton matRipple status="primary" class="btn" (click)="uploader.click()"
                *ngIf="imageChangedEvent == null && selectedImage == null">
                Upload
                <!-- {{'components.img-cropper.upload' | translate}} -->
            </button>
            <button nbButton matRipple status="warning" ghost class="btn" (click)="clearImg()"
                *ngIf="imageChangedEvent == null && selectedImage != null">
                Clear
                <!--   {{'components.img-cropper.clear' | translate}} -->
            </button>

            <button nbButton matRipple status="primary" class="btn" (click)="cutImg()"
                *ngIf="imageChangedEvent != null">
                Cut
                <!-- {{'components.img-cropper.cut' | translate}} -->
            </button>
            <button nbButton matRipple status="warning" class="btn" (click)="cancelImg()"
                *ngIf="imageChangedEvent != null" ghost>
                Cancel
                <!-- {{'components.img-cropper.cancel' | translate}} -->
            </button>
        </div>
    </nb-card-footer>
</nb-card>